import { Service } from "typedi";
import { IGooglePayButtonDomInjector } from "./IGooglePayButtonDomInjector";

@Service()
export class GooglePayButtonDomInjector implements IGooglePayButtonDomInjector {
  addButtonToDom(buttonRootNode: string, button: Node): void {
    const rootElement = document.getElementById(buttonRootNode);
    if (rootElement) {
      while (rootElement.firstChild) {
        rootElement.removeChild(rootElement.firstChild);
      }
      rootElement.appendChild(button);
    }
  }
}
